'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Dock = require('./Dock');

var _Dock2 = _interopRequireDefault(_Dock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dock2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-dock/lib/index.js
// module id = 1597
// module chunks = 0